import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tutorial_square.png'
import _imports_1 from '@/assets/images/tutorial_guessing.png'
import _imports_2 from '@/assets/images/tutorial_row.png'
import _imports_3 from '@/assets/images/tutorial_keyboard.png'


const _withScopeId = n => (_pushScopeId("data-v-69a2b606"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dialog-title-text" }, " Bem Vindo! ")
], -1))
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Adivinhe as 5 palavras horizontais em até 15 tentativas. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Depois de cada tentativa, o quadrado mostra o quão perto você está de finalizar o jogo. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-section-title" }, " O quadrado ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " As 5 palavras verticais também são palavras válidas e podem servir para ajudar a adivinhar as 5 palavras horizontais. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-section-title" }, " Chutando ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-section-title" }, " Palavra horizontal ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-section-title" }, " Cores do teclado ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-section-title" }, " Boa Sorte! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    onHide: _ctx.hide,
    ref: "dialogRef"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_q_img, {
                  class: "img-square",
                  src: _imports_0
                }),
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_q_img, {
                  class: "img-guessing",
                  src: _imports_1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_q_img, {
                  class: "img-row",
                  src: _imports_2
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createVNode(_component_q_img, {
                  class: "img-keyboard",
                  src: _imports_3
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, { class: "dialog-section" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createVNode(_component_q_card_actions, {
                  class: "actions",
                  align: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      onClick: _ctx.hide,
                      flat: "",
                      label: "Ok"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}